// extracted by mini-css-extract-plugin
export var border = "_80-0";
export var borderSelected = "_80-1";
export var check = "_80-6";
export var circle = "_80-2";
export var circleInner = "_80-4";
export var circleInnerDisabled = "_80-8";
export var description = "_80-3";
export var horizontal = "_80-b";
export var input = "_80-5";
export var label = "_80-9";
export var radioButton = "_80-d";
export var radioButtonNoCenter = "_80-e";
export var radioGroup = "_80-a";
export var rightRadio = "_80-f";
export var subcontent = "_80-g";
export var uncheck = "_80-7";
export var vertical = "_80-c";